export default function (id) {
  let window = `relatorio.remocao.entradaSaida`
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Relatório de Entrada/Saída de Bens',
    width: '600',
    height: '450',
    minHeight: '500px',
    backdrop: false,
    maximize: false,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
      id: id
    }
  }, () => import('./RemocaoEntradaSaida.vue'))
    .then((wid) => {
      console.log(wid)
    }) // return wid
}
